
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class GstReportSummaryWithGstinDialog extends Serenity.EntityDialog<GstReportSummaryWithGstinRow, any> {
        protected getFormKey() { return GstReportSummaryWithGstinForm.formKey; }
        protected getIdProperty() { return GstReportSummaryWithGstinRow.idProperty; }
        protected getLocalTextPrefix() { return GstReportSummaryWithGstinRow.localTextPrefix; }
        protected getNameProperty() { return GstReportSummaryWithGstinRow.nameProperty; }
        protected getService() { return GstReportSummaryWithGstinService.baseUrl; }
        protected getDeletePermission() { return GstReportSummaryWithGstinRow.deletePermission; }
        protected getInsertPermission() { return GstReportSummaryWithGstinRow.insertPermission; }
        protected getUpdatePermission() { return GstReportSummaryWithGstinRow.updatePermission; }

        protected form = new GstReportSummaryWithGstinForm(this.idPrefix);

    }
}